<template>
    <div class="card">
        <div class="card-header">
            培训基地印章信息
        </div>
        <div class="card-body">
            <div class="text-center" v-if="organSealInfo">
                <img alt="seal picture" :src="URL_ROOT + organSealInfo.sealPicture" style="width: 300px; height: 300px;" class="img-thumbnail p-3 bg-light">
            </div>
            <div v-else class="alert alert-warning mb-0">没有印章信息，请上传</div>
        </div>
        <div class="card-footer text-center">
            <button class="btn btn-primary mr-2" @click="btnUploadHeaderImageClick">上传图片</button>
            <input type="file" name="uploadFile" accept="image/*"
                   style="display: none" ref="uploadFile" @change="uploadFileChange">
        </div>
    </div>
</template>

<script>
import url from "@/utils/api/url";
import userApi from "@/utils/api/user";
import commonApi from "@/utils/api/common";
export default {
    name: "OrganSealEdit",
    props: {
        organId: {type: String, required: true},
    },
    data: function () {
        return {
            URL_ROOT: url.URL_ROOT,
            organSealInfo: null,
        };
    },
    mounted() {
        this.getOrganSealInfo();
    },
    methods: {
        getOrganSealInfo() {
            userApi.organ.seal.getOrganSealInfo(this.organId).then(res => {
                this.organSealInfo = res.data;
            });
        },

        btnUploadHeaderImageClick() {
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'SealImage').then(result => {
                // console.log(result.data);
                let info = {
                    organId: this.organId,
                    sealPicture: result.data.address
                };

                if (this.organSealInfo) {
                    // 存在，修改
                    userApi.organ.seal.updateOrganSealInfo(info).then(res => {
                        this.getOrganSealInfo();
                    });
                }
                else {
                    userApi.organ.seal.insertOrganSealInfo(info).then(res => {
                        this.getOrganSealInfo();
                    });
                }
            });
        },
    }
}
</script>

<style scoped>

</style>